import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  search() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      const form = this.element.tagName === 'FORM' ? this.element : this.element.querySelector('form')

      if (form) {
        const url = new URL(form.action)
        url.searchParams.set("query", this.inputTarget.value)

        fetch(url.toString(), {
          headers: { "Accept": "text/vnd.turbo-stream.html" }
        })
        .then(response => response.text())
        .then(html => {
          Turbo.renderStreamMessage(html)
          this.reinitializeDropdowns()
        })
        .catch(error => {
          console.error('Erro na busca:', error)
        })
      }
    }, 300)
  }

  reinitializeDropdowns() {
    setTimeout(() => {
      if (typeof initFlowbite !== 'undefined') {
        initFlowbite()
      } else if (window.Flowbite && window.Flowbite.initDropdowns) {
        window.Flowbite.initDropdowns()
      }
    }, 100)
  }
}